// token 信息
const TOKEN_KEY = 'token'
const WX_MP_APPID_KEY = 'wx_mp_appid'
const USER_INFO_KEY = 'user_info'

export function getToken() {
    return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
    return localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
    return localStorage.removeItem(TOKEN_KEY)
}

export function getWxMpAppId() {
    return sessionStorage.getItem(WX_MP_APPID_KEY)
}

export function setWxMpAppId(appId) {
    return sessionStorage.setItem(WX_MP_APPID_KEY, appId)
}

export function clearWxMpAppId() {
    return sessionStorage.removeItem(WX_MP_APPID_KEY)
}

export function setUserInfoCache(userInfo) {
    return localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo || {}))
}

export function getUserInfoCache() {
    const raw = localStorage.getItem(USER_INFO_KEY)
    return raw ? JSON.parse(raw) : null
}

export function removeUserInfoCache() {
    return localStorage.removeItem(USER_INFO_KEY)
}